module.exports = __webpack_public_path__ + "static/media/mobbiz-logo.30a54184.png";